import { render, staticRenderFns } from "./deleteShopReturnAddress.vue?vue&type=template&id=2ba35862&scoped=true"
import script from "./deleteShopReturnAddress.vue?vue&type=script&lang=js"
export * from "./deleteShopReturnAddress.vue?vue&type=script&lang=js"
import style0 from "./deleteShopReturnAddress.vue?vue&type=style&index=0&id=2ba35862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba35862",
  null
  
)

export default component.exports